/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/styles";
import Cancel from "@material-ui/icons/CancelPresentationSharp";
import { loadingComponent, notLoadingComponent } from "../../../actions/isLoadingActions";
import "./../styles.css";
import { Box, Card, CardContent, Container } from "@material-ui/core";
import swalert from "sweetalert";
import { DeleteOutline } from "@material-ui/icons";
import { MuiThemeProps } from "../../../theme/theme";
import { useMutation } from "@apollo/react-hooks";
import {
  DeleteOneProject,
  DeleteOneProjectVariables,
  ProjectGallery_projects_edges_node,
} from "../../../data/graphQLModel";
import { MUTATION_DELETE_ONE_PROJECT } from "../../../data/graphQLQueries";

const useStyles = makeStyles((theme: MuiThemeProps) => ({
  formControl: {
    margin: theme.spacing(5),
    minWidth: 200,
  },
  form: {
    width: "80%",
  },
  margin: {
    width: "60ch",
    marginBottom: "4ch",
  },
  marginCode: {
    width: "40ch",
    marginBottom: "4ch",
  },
}));

export default function DeleteProject() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation<ProjectGallery_projects_edges_node[]>();
  const [project, setProject] = useState<ProjectGallery_projects_edges_node>();
  let m = undefined;

  const validateimg = () => {
    if (location.state[0] === undefined) {
      history.push("/customerstables/projects");
      return;
    }

    m = location.state;
    setProject(location.state[0]);

    if (m === undefined) {
      history.push("/customerstablesprojects");
      return;
    }
  };

  useEffect(() => {
    validateimg();
  }, []);

  const [mutationDeleteOneProject] = useMutation<DeleteOneProject, DeleteOneProjectVariables>(
    MUTATION_DELETE_ONE_PROJECT
  );

  async function submitForm(e: any) {
    e.preventDefault();

    dispatch(loadingComponent());

    try {
      var res = await mutationDeleteOneProject({
        variables: {
          input: {
            id: project?.id as string,
          },
        },
      });
      if (res) swalert("Success.", "Project delete with success", "success");
    } catch (error) {
      dispatch(notLoadingComponent());
      swalert("Failed.", typeof error === "string" ? error : "Erro", "error");
      return;
    }
    dispatch(notLoadingComponent());
    history.push("/customerstables/projects");
  }

  function handleCancel(event: any) {
    event.preventDefault();
    history.push("/customerstables/projects");
  }

  return (
    <div className="container">
      <Container style={{ marginTop: "70px" }}>
        <Box style={{ marginBottom: "10px" }}>
          <Card>
            <CardContent>
              <h2 style={{ marginBottom: "-10px" }}>Delete Project</h2>
            </CardContent>
          </Card>
        </Box>
        <hr />
        <Card>
          <CardContent>
            <form className={classes.form} onSubmit={submitForm} style={{ width: "100%" }}>
              {project && (
                <>
                  <div>
                    <FormControl fullWidth className={classes.marginCode} variant="outlined">
                      <TextField
                        disabled
                        id="CodeProject"
                        label="Code"
                        name="code"
                        placeholder="Code"
                        defaultValue={project.code}
                        variant="outlined"
                      />
                    </FormControl>
                  </div>
                  <div>
                    <FormControl fullWidth className={classes.margin} variant="outlined">
                      <TextField
                        disabled
                        id="projProject"
                        label="Project"
                        name="project"
                        placeholder="Project"
                        defaultValue={project.project}
                        variant="outlined"
                      />
                    </FormControl>
                  </div>
                  <div>
                    <FormControl fullWidth className={classes.margin} variant="outlined">
                      <TextField
                        disabled
                        id="descProject"
                        label="Description"
                        name="description"
                        placeholder="Description"
                        defaultValue={project.description}
                        variant="outlined"
                      />
                    </FormControl>
                  </div>
                  <div>
                    <FormControl fullWidth className={classes.margin} variant="outlined">
                      <TextField
                        disabled
                        id="obsProjet"
                        label="Observation"
                        name="Observation"
                        placeholder="Observation"
                        defaultValue={project.observation}
                        variant="outlined"
                      />
                    </FormControl>
                  </div>
                </>
              )}
              <div className="btnform" style={{ justifyContent: "space-between", width: "100%" }}>
                <div>
                  <FormControl fullWidth style={{ margin: "15px" }} variant="outlined">
                    <Button
                      onClick={handleCancel}
                      fullWidth
                      variant="contained"
                      style={{ height: "50px", width: "200px", fontSize: "20px" }}
                    >
                      Cancel
                      <Cancel style={{ marginLeft: "20px" }} />
                    </Button>
                  </FormControl>
                </div>
                <div>
                  <FormControl fullWidth variant="outlined" style={{ margin: "15px" }}>
                    <Button
                      onClick={submitForm}
                      type="submit"
                      fullWidth
                      variant="contained"
                      style={{ height: "50px", width: "200px", fontSize: "20px" }}
                      color="secondary"
                    >
                      Delete
                      <DeleteOutline style={{ marginLeft: "20px" }} />
                    </Button>
                  </FormControl>
                </div>
              </div>
            </form>
          </CardContent>
        </Card>
      </Container>
    </div>
  );
}
